module.exports = __webpack_public_path__ + "static/media/VLC_BG_2.35efccc3.jpg";